var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"card-border"},[_c('v-card-title',[_vm._v(" Erros na Geração dos Materiais ")]),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }